import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const getResourceDetails = (resource_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/resources/'+resource_id ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const createResource = (postFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/resources' ;

    return getDataWithPromise(url, 'POST', { formData: postFormData })
}

export const updateResource = (resource_id, postFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/resources/' + resource_id ;

    getDataWithPromise(url, 'POST', { formData: postFormData }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const deleteResource = (resource_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/resources/' + resource_id ;

    getDataWithPromise(url, 'DELETE', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getResources = (child_uid, type, approved, onCompleteFunc) => {
    const approvedOnly = approved ? '&approved=' + approved : '';

    const url = Globals.APIFolder + '/child/' + child_uid +  '/resources?type_id=' + type + approvedOnly ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getMyResources = (user_id, type, onCompleteFunc) => {

    const url = Globals.APIFolder + '/users/' + user_id +  '/resources?type_id=' + type ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const updateResourceAccessForChild = (child_uid, resource_id, onOff, onCompleteFunc) => {

    const url = Globals.APIFolder + '/resources/' + resource_id + '/child/' + child_uid + '?onOff=' + onOff;

    getDataWithPromise(url, 'put', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}



